/**
 * Schutz gegen Formel-Einschleusung: Ein Teamname wie `=HYPERLINK(…)` oder
 * `@SUMME(…)` würde Excel beim Öffnen als Formel ausführen. Solche Zellen
 * bekommen ein `'` davor — Excel zeigt dann den Text. Reine Zahlen wie `-5`
 * (Punktdifferenz) oder `+3` bleiben Zahlen.
 */
function neutralisiere(s: string): string {
  if (!/^[=+\-@\t\r]/.test(s)) return s;
  if (/^[+-]?\d+(?:[.,]\d+)?$/.test(s)) return s;
  return `'${s}`;
}

/**
 * CSV für Excel und LibreOffice: Semikolon als Trenner (deutsche und
 * italienische Excel-Installationen erwarten das), Anführungszeichen nur wo
 * nötig, BOM davor, damit Umlaute richtig ankommen. Vorher hatten Kassenliste
 * und Saisontabelle zwei verschiedene Dialekte.
 */
export function csvCell(v: string | number | undefined | null): string {
  const s = neutralisiere(v === undefined || v === null ? '' : String(v));
  return /[;"\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function csvLine(cells: (string | number | undefined | null)[]): string {
  return cells.map(csvCell).join(';');
}

export function csvFile(lines: (string | number | undefined | null)[][]): string {
  return '\ufeff' + lines.map(csvLine).join('\r\n');
}
